import feedbackPage from './js/page/feedback';

export default {
    feedback: feedbackPage,
    'feedback-filter': feedbackPage
};
